<template>
  <div id="service-process">
    <!--    <ul class="table">-->
    <!--      <li-->
    <!--        class="item"-->
    <!--        @click="handleItemClick(item)"-->
    <!--        v-for="item of list"-->
    <!--        :key="item.id"-->
    <!--      >-->
    <!--        <span class="iconfont" v-html="item.icon"></span>-->
    <!--        <span class="title">{{ item.title }}</span>-->
    <!--      </li>-->
    <!--    </ul>-->
    <!--    <div class="service-img">-->
    <!--      <img :src="imgUrl" alt="" />-->
    <!--    </div>-->
    <el-tabs type="border-card">
      <el-tab-pane v-for="item of list" :key="item.id">
        <span slot="label"
          ><span class="iconfont" v-html="item.icon"></span>
          {{ item.title }}</span
        >
        <img :src="item.imgUrl" alt="" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "ServiceProcess",
  components: {},
  data() {
    return {
      activeName: "",
      imgUrl: require("../../../../assets/images/blueCross/process.png"),
      list: [
        {
          id: 1,
          title: "服务流程",
          imgUrl: require("../../../../assets/images/blueCross/process.png"),
          icon: "&#xe624;"
        },
        {
          id: 2,
          title: "项目服务",
          imgUrl: require("../../../../assets/images/blueCross/process.png"),
          icon: "&#xe9d8;"
        },
        {
          id: 3,
          title: "服务套餐",
          imgUrl: require("../../../../assets/images/blueCross/process.png"),
          icon: "&#xe679;"
        },
        {
          id: 4,
          title: "生活住宿",
          imgUrl: require("../../../../assets/images/blueCross/process.png"),
          icon: "&#xe642;"
        },
        {
          id: 5,
          title: "签证办理",
          imgUrl: require("../../../../assets/images/blueCross/process.png"),
          icon: "&#xe613;"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    handleClick() {},
    handleItemClick(e, item) {
      console.log(item);
      console.log(e);
    }
  }
};
</script>

<style lang="scss" scoped>
#service-process {
  height: 635px;
  width: 100%;
  .table {
    height: 65px;
    display: flex;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    .item {
      flex: 1;
      border-right: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .iconfont {
        font-size: 26px;
        color: #b7b7b7;
      }
      .title {
        font-size: 18px;
        color: #b7b7b7;
        margin-left: 5px;
      }
    }
  }
  .service-img {
    img {
      width: 100%;
    }
  }
  .el-tabs__nav {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-tabs__item {
      flex: 1;
    }
  }
  .el-tabs__content {
    img {
      width: 100%;
    }
  }
  .el-tabs__content {
    padding: 15px !important;
  }
}
</style>
